import { useAppSelector } from '~/app/hooks'
import { isDarkTheme } from '~/redux/features'

export function EFDownloadIcon() {
  const isDark = useAppSelector(isDarkTheme)
  const color = isDark ? 'var(--color-dark-theme)' : 'var(--icon-color-light-theme)'
  return (
    <svg
      width='15'
      height='15'
      viewBox='0 0 15 15'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M14 11V14H1.5V11H0.5V14C0.5 15.0109 0.837856 15.0083 1.74645 15.0013C1.82648 15.0007 1.91095 15 2 15H14C14.55 15 14.8 15.025 14.9125 14.9125C15.025 14.8 15 14.55 15 14V11H14ZM13 7L12 6.5L8.5 9.5V1.76243e-05L7 0V9.5L4 6.5L3 7L8 12L13 7Z'
        fill={color}
      />
      <path
        d='M14 11V14H1.5V11H0.5V14C0.5 15.0109 0.837856 15.0083 1.74645 15.0013C1.82648 15.0007 1.91095 15 2 15H14C14.55 15 14.8 15.025 14.9125 14.9125C15.025 14.8 15 14.55 15 14V11H14ZM13 7L12 6.5L8.5 9.5V1.76243e-05L7 0V9.5L4 6.5L3 7L8 12L13 7Z'
        stroke={color}
      />
    </svg>
  )
}
